/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { createOrUpdateNotificationModelSchema } from "../createOrUpdateNotificationModelSchema.ts";
import { guidCreatedOrUpdatedEntityModelSchema } from "../guidCreatedOrUpdatedEntityModelSchema.ts";
import { z } from "zod";

export const putApiNotificationsIdPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор push-уведомления")
    })

/**
 * @description Идентификатор обновляемого уведомления
 */
export const putApiNotificationsId200Schema = z.lazy(() => guidCreatedOrUpdatedEntityModelSchema)

/**
 * @description Push уведомление уже существует (заголовок или тип отправки при первом входе)
 */
export const putApiNotificationsId400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const putApiNotificationsId401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const putApiNotificationsId403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Push уведомление не найдено
 */
export const putApiNotificationsId404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const putApiNotificationsId500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const putApiNotificationsIdMutationRequestSchema = z.lazy(() => createOrUpdateNotificationModelSchema).describe("Тело запроса")

export const putApiNotificationsIdMutationResponseSchema = z.lazy(() => putApiNotificationsId200Schema)